import React from 'react';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import PageBreak from '../../layout/PageBreak';
import Col from '../../layout/Col';
import Input from '../../forms/Input';
import Form from '../../forms/Form';
import Checkbox from '../../forms/Checkbox';
import Heading from '../../forms/Heading';
import Select from '../../forms/Select';
import { useGlobalState } from '../../stateProvider/StateProvider';
import { HSOptions } from '../../../constants/HSOptions';
import Button from '../../forms/Button';
import Table from '../../table/Table';
import { addSuffix, generateId } from '../../utility/functions';
import Preput from '../../forms/Preput';
import GetState from '../../GetState';
import ManagementRow from '../../table/ManagementRow';
import TaxRates from './TaxRates';
import { IsAuthorized, userRoles } from '../../RoleProtected';
import ModalFactory from '../../Modal';

const LocationManagement = ({ ...props }) => {
    const {
        state: {
            states,
        },
    } = useGlobalState();

    const betaTester = IsAuthorized(userRoles.betaTester);

    const [locations, refreshLocations] = GetState(QuestRoute.settings.locations)

    const editLocation = (loc, locations) => {
        const id = generateId();
        ModalFactory.show({
            id,
            title: `Edit ${loc.locationName}`,
            body: (
                <Form
                    inputs={{ ...loc }}
                    onSubmit={e => (
                        HamQuest.put(QuestRoute.settings.locations + '/' + loc.locationId, { ...e })
                            .then(() => {
                                ModalFactory.close(id);
                                refreshLocations();
                            })
                    )}
                    text='Update'
                >
                    {({ values }) => (
                        <>
                            <Input
                                label='Location'
                                name='locationName'
                                required
                            />
                            <Input
                                label='Address'
                                name='address1'
                                required
                            />
                            <Input
                                label='Address 2'
                                name='address2'
                            />
                            <Input
                                label='City'
                                name='city'
                                required
                            />
                            <Input
                                label='Zip'
                                name='zip'
                                required
                            />
                            <Select
                                label='State'
                                name='state'
                                options={states}
                                required
                            />
                            <Select
                                label='Country'
                                name='country'
                                options={HSOptions.countries}
                                required
                            />
                            <Select
                                label='Time Zone'
                                name='timeZone'
                                options={HSOptions.timeZones}
                                required
                            />
                            <Preput
                                label='Details'
                                name='details'
                            />
                            <Input
                                label='Longitude'
                                name='longitude'
                                type='number'
                            />
                            <Input
                                label='Latitude'
                                name='latitude'
                                type='number'
                            />

                            {betaTester && (
                                <>
                                    <Heading>Tax Rates (Check in the order applied)</Heading>
                                    {GetState(QuestRoute.taxesRates.taxes, { loading: [] })[0].map(e => {
                                        const index = values.locationTaxes.indexOf(e.taxRateId);
                                        return (
                                            <Checkbox
                                                label={`${e.description} ${index !== -1 ? `- ${addSuffix(index + 1)}` : ''}`}
                                                name='locationTaxes'
                                                value={e.taxRateId}
                                            />
                                        )
                                    })}
                                </>
                            )}
                        </>
                    )}
                </Form>
            )
        })
    }

    const locationsTableConfig = {
        data: locations,
        disableHeaderSearch: true,
        headers: [
            {
                label: 'Location Name',
                propKey: 'locationName',
            }, {
                label: 'Country Name',
                propKey: 'country',
            }, {
                label: 'City',
                propKey: 'city',
            }, {
                label: 'State',
                propKey: 'state',
            }, {
                label: 'Location ID',
                propKey: 'locationId',
            }, {
                label: 'License Status',
                propKey: 'licenseStatus',
            }, betaTester ? {
                label: 'Tax Rate',
                propKey: 'taxRate',
            } : null
        ].filter(e => e),
        renderFormat: (e, data) => (
            <ManagementRow
                key={generateId()}
                controls={[
                    <Button onClick={() => editLocation(e, data)} key={generateId()} >Edit</Button>
                ]}
            >
                <td>{e.locationName}</td>
                <td>{e.country}</td>
                <td>{e.city}</td>
                <td>{e.state}</td>
                <td>{e.locationId}</td>
                <td>{e.licenseStatus}</td>
                {betaTester ? <td>{e.locationTaxes.length > 0 ? 'Has Taxes' : '-'}</td> : null}
            </ManagementRow>
        )
    }

    return (
        <PageBreak>
            <Table config={locationsTableConfig} />
            {betaTester ? <TaxRates /> : (
                <Col>
                    <Heading>Tax Rates</Heading>
                    <span>Coming soon, please submit a Feedback form to sign up for testing!</span>
                </Col>
            )}
        </PageBreak>
    );
}

export default LocationManagement;